import api from './api';

export const anexarDocumentoConsulta = async (
  idConsultaSolicitacao,
  arquivo
) => {
  const formData = new FormData();
  formData.append('arquivo', arquivo);

  return api.post(`/documento-consulta/${idConsultaSolicitacao}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getDocumentosByProtocolo = async (idDocumento, protocolo) => {
  const queryString = `${idDocumento}/${protocolo}`;

  try {
    const response = await api.get(`/documento-consulta/${queryString}`, {
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const ativarDocumento = async (idDocumento, protocolo) => {
  const queryString = `${idDocumento}/${protocolo}`;

  try {
    const response = await api.put(`/documento-consulta/ativar/${queryString}`);
    return response;
  } catch (error) {
    return { error };
  }
};

export const inativarDocumento = async (idDocumento, protocolo) => {
  const queryString = `${idDocumento}/${protocolo}`;

  try {
    const response = await api.put(
      `/documento-consulta/inativar/${queryString}`
    );
    return response;
  } catch (error) {
    return { error };
  }
};

export const atualizarDataValidadeDocumento = async (
  idDocumento,
  protocolo,
  dataValidade
) => {
  const queryString = `${idDocumento}/${protocolo}`;

  return api.put(`/documento-consulta/validade/${queryString}`, {
    dataValidade,
  });
};
